import { ApiEndPoints, NetworkManager } from "../network";

export class AuthService {
  static getAuthEntity = () => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const hospital = JSON.parse(localStorage.getItem("hospital") || "null");
    return user || hospital || null;
  };

  static isLoggedin = () => {
    const entity = this.getAuthEntity();
    return entity?.accessToken ? true : false;
  };

  static login = async (email, password) => {
    const response = await NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.login,
      data: { email, password },
    });

    if (response?.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response;
  };

  static hospitalLogin = async (email, password) => {
    const response = await NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.hospitalLogin,
      data: { email, password },
    });

    if (response?.data) {
      localStorage.setItem("hospital", JSON.stringify(response.data));
    }
    return response;
  };

  static resetPassword = (email, password) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.forgotPassword,
      data: { email, password },
    });
  };

  static setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
  };

  static setHospital = (hospital) => {
    localStorage.setItem("hospital", JSON.stringify(hospital));
  };

  static logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("hospital");
  };

  static getUserRole = () => {
    const entity = this.getAuthEntity();
    return entity?.roleDetails || null;
  };

  static isSuperAdmin = () => {
    const role = this.getUserRole();
    return role?.role === "Super Admins";
  };

  static canUpdate = () => {
    const roleId = this.getUserRole()?.id;
    return [1].includes(roleId);
  };

  static getAccessToken = () => {
    const entity = this.getAuthEntity();
    return entity?.accessToken || null;
  };
}
